import React from 'react';
import PropTypes from 'prop-types';
import {
  Icon,
  Heading,
  TextWithTooltip,
  Text
} from 'components/common/Elements/Elements';

import classes from './Gateways.module.scss';

const Gateways = ({ data }) => {
  return (
    <div className={classes.widjet}>
      <div className={classes.iconWrap}>
        <Icon size="14px" icon={'server'} color="#3a5ba2" />
      </div>
      <div className={classes.overflow}>
        <Heading className={classes.overflow}>
          <TextWithTooltip
            text={data.gatewayDns}
            saveNotification="activity:platform.TEXT_COPY"
          />
        </Heading>
        <Text>
          <TextWithTooltip
            text={data.gatewayIp}
            saveNotificat
            ion="activity:platform.TEXT_COPY"
          />
        </Text>
      </div>
    </div>
  );
};

Gateways.propTypes = {
  data: PropTypes.object.isRequired
};

export default Gateways;
